import css from "../style.module.css";
import { SidebarItems } from "./SidebarItems";
import { SidebarHeader } from "./SidebarHeader";
import { useDashboardContext } from "../Provider";

interface SidebarProps {
  mobileOrientation: "start" | "end";
}

const style = {
  mobileOrientation: {
    start: "left-0",
    end: "right-0",
  },
  close: "hidden",
  container: "pb-32 lg:pb-6",
  open: "w-8/12 absolute z-40 sm:w-5/12",
  default:
    "bg-gray-200 overflow-y-auto h-screen top-0 lg:bg-transparent lg:block lg:relative lg:w-64 lg:z-auto",
};

export function Sidebar({ mobileOrientation }: SidebarProps) {
  const { sidebarOpen } = useDashboardContext();
  return (
    <aside
      className={`${style.default} 
         ${style.mobileOrientation[mobileOrientation]} 
         ${sidebarOpen ? style.open : style.close} ${css.sidebarScrollbar}`}
    >
      <div className={style.container}>
        {/* <div className="relative">
          <span className="absolute w-16 h-16 right-0">X</span>
        </div> */}
        <img src="logo.png" alt="logo" className="w-3/5 h-auto mt-5 mx-auto" />
        {/* <SidebarHeader /> */}
        <SidebarItems />
      </div>
    </aside>
  );
}
